/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homefeatureseyebrow2Inputs */



/**
* | output |
* | --- |
* | "Everything in one place" |
*
* @param {Homefeatureseyebrow2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homefeatureseyebrow2 = /** @type {((inputs?: Homefeatureseyebrow2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homefeatureseyebrow2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Everything in one place")
	return /** @type {LocalizedString} */ ("Alles an einem Ort")
});
export { homefeatureseyebrow2 as "homeFeaturesEyebrow" }